<template>
    <div class="hero" :style="`background-image: url('${imgURL}');`" >
        <div class="content">
            <p class="small_title">
                {{sectionTitle}}
            </p>
            <h1 class="title">
                {{title}}
            </h1>
            <hr>
            <p v-html="content">
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name:"HeroBlock",
    props:{
        sectionTitle:{
            type: String,
            default: ''  
        },
        title:{
            type: String,
            default: ''
        },
        content:{
            type: String,
            default: ''
        },
        imgURL:{
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.hero{
    color: #fff;
    display:flex;
    align-items: center;
    height: 75vh;
    max-height: 550px;
    background-size: cover;
    background-position:center;
    background-repeat: no-repeat;
    position: relative;
    &::before{
        content: ""; // ::before and ::after both require content
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(#000, #000);
        opacity: .35;
        z-index: 2;
    }
    .content{
        margin-left: 4rem;
        width: 40%;
        z-index: 3;
        .small_title{
            text-transform: uppercase;
            margin: 0;
        }
        h1{
            font-size: 63.5px;
            letter-spacing: 1.5px;
            font-weight: 500;
            margin: 22px 0;
            line-height: 60px;
        }
        p{
            margin-top: 22px;
            color: #fff;
            white-space:normal;
            word-break: keep-all;
            max-width: 400px;
        }
        hr{
            border: 0;
            border-bottom: 1px solid #fff;
        }
    }
}

@media (max-width: $mobile) { 
    .hero{
        height: 45vh;
        max-height: 350px;
        .content{
            width: 100%;
            margin: 0 2rem;
            h1{
                margin: 1rem 0;
                font-size: 51px;
            }
        }
    }
}
</style>